import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const CompetitiveExamBookMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        bookName: "",
        competitiveExamNameMasterId: '',
        publicationMasterId: '',
        subjects: ['']
    }
    const [formData, setFormData] = useState([])
    const [syllabusData, setSyllabusData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([]);
    const [competitiveExamNameList, setCompetitiveExamNameList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNewExamBook, setAddNewExamBook] = useState(false);

    const [examNameSort, setExamNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [publicationNameSort, setPublicationNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["competitiveExamNameMasterDetails.examName", "competitiveExamBookMasterDetails.subjectMasterDetails.subjectName", "publicationMasterDetails.publicationName", "bookName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });
        getCompetitiveExamNameList()
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (syllabusData.competitiveExamNameMasterId !== '') {
                setCurrPage(1);
                let apiUrl = '/get-competitive-exam-book-master?';

                if (syllabusData.publicationMasterId) {
                    apiUrl += `publicationMasterId=${syllabusData.publicationMasterId}&`;
                }

                if (syllabusData.competitiveExamNameMasterId) {
                    apiUrl += `competitiveExamNameMasterId=${syllabusData.competitiveExamNameMasterId}&`;
                }

                if (syllabusData.subjects) {
                    apiUrl += `subjects=${syllabusData.subjects}&`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setSyllabusList(await searchArray("A", apiUrl, searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (syllabusData.competitiveExamNameMasterId !== '') {
            let apiUrl = '/get-competitive-exam-book-master?';

            if (syllabusData.publicationMasterId) {
                apiUrl += `publicationMasterId=${syllabusData.publicationMasterId}&`;
            }

            if (syllabusData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${syllabusData.competitiveExamNameMasterId}&`;
            }

            if (syllabusData.subjects.length > 0) {
                apiUrl += `subjects=${syllabusData.subjects}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSyllabusList(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [syllabusData, refresh]);

    const getExamBookList = () => {
        if (syllabusData.competitiveExamNameMasterId !== '') {
            let apiUrl = '/get-competitive-exam-book-master?';

            if (syllabusData.publicationMasterId) {
                apiUrl += `publicationMasterId=${syllabusData.publicationMasterId}&`;
            }

            if (syllabusData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${syllabusData.competitiveExamNameMasterId}&`;
            }

            if (syllabusData.subjects.length > 0) {
                apiUrl += `subjects=${syllabusData.subjects}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSyllabusList(response.data.data);
                    setAddNewExamBook(!addNewExamBook)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewExamBook])

    useEffect(() => {
        setTotalPages(Math.ceil(syllabusList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > syllabusList.length) {
            endIndex = syllabusList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(syllabusList.slice(startIndex, endIndex));
    }, [syllabusList, currPage, itemsPerPage]);

    const getCompetitiveExamNameList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setCompetitiveExamNameList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSelectExamName = (e, index) => {
        setSyllabusData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        });

        const apiUrl = `/get-competitive-exam-names-wise-subject?competitiveExamNameMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSyllabusData((prevData) => {
                    return {
                        ...prevData,
                        subjects: [''],
                    }
                })
                setSubjectList(response.data.result);
                // console.log("response subject", response.data.result);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }

    const SubList = subjectList?.map((sub) => {
        return {
            value: sub.subjectMasterDetails.id,
            label: sub.subjectMasterDetails.subjectName
        }
    }) || [];

    const handleChangeSub = (selectedOptions) => {
        console.log(selectedOptions)
        const selectedIds = selectedOptions.map((option) => option.value.toString());

        console.log(selectedIds)
        setSyllabusData((prevData) => {
            return {
                ...prevData,
                subjects: selectedIds,
            }
        })
    }

    const handleInputChange = (e, index) => {
        setSyllabusData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else if (e.target.name === "bookName") {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value.toUpperCase(),
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        })
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(syllabusData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [syllabusData])

    const addSyllabusType = () => {
        const apiUrl = `/add-competitive-exam-book-master`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, syllabusData)
                .then(response => {
                    getExamBookList();
                    setSyllabusData((prevData) => {
                        return {
                            ...prevData,
                            bookName: [''],
                        }
                    })

                    setSaveId(response.data.result.id);
                    setExamNameSort(null);
                    setSubjectSort(null);
                    setPublicationNameSort(null);
                    setBookNameSort(null);
                    setSearchValue(null);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value == '' || value.length !== 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                }
                else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSyllabus = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-competitive-exam-book-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSyllabus = () => {
        setLoading(true);
        const apiUrl = `/edit-competitive-exam-book-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, syllabusData)
            .then(response => {
                setEditId(null);
                setSyllabusData((prevData) => {
                    return {
                        ...prevData,
                        bookName: [''],
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleReset = () => {
        setSyllabusList([]);
        setEditId('');
        setSyllabusData(initialFormState);
        setExamNameSort(null);
        setSubjectSort(null);
        setPublicationNameSort(null);
        setBookNameSort(null);
        setError(initialErrorState);
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setSubjectSort(null);
            setPublicationNameSort(null);
            setBookNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setExamNameSort(null);
            setPublicationNameSort(null);
            setBookNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (publicationNameSort == true || publicationNameSort == false) {
            setExamNameSort(null);
            setSubjectSort(null);
            setBookNameSort(null);
        }
    }, [publicationNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectSort(null);
            setPublicationNameSort(null);
        }
    }, [bookNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Book</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-book-open"></i> Competitive Exam Book </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Name :</label>
                                                    <select class="form-select" aria-label="Default select example" name='competitiveExamNameMasterId' onChange={handleSelectExamName} value={syllabusData.competitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam Name</option>
                                                        {
                                                            competitiveExamNameList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.competitiveExamNameMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <Select
                                                        value={SubList.filter(option =>
                                                            syllabusData.subjects && syllabusData.subjects.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="subjects"
                                                        options={SubList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeSub}
                                                    />
                                                    {error.subjects && <p style={{ color: 'red' }}>{error.subjects}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Publication :</label>
                                                    <select class="form-select" aria-label="Default select example" name='publicationMasterId' onChange={handleInputChange} value={syllabusData.publicationMasterId}>
                                                        <option selected value={''} disabled>Select Publication</option>
                                                        {
                                                            formData?.publicationData?.map((publication) => {
                                                                return <option value={publication.id}>{publication.publicationName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.publicationMasterId && <p style={{ color: 'red' }}>{error.publicationMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Book Name :</label>
                                                    <input type="text" className="form-control" id={`bookName`} name='bookName' onChange={handleInputChange} value={syllabusData.bookName} />
                                                    {error.bookName && <p style={{ color: 'red' }}>{error.bookName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addSyllabusType}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon delete_icon" type="button" onClick={handleReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSyllabus} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Competitive Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Publication
                                                                            <SortIcon sortState={publicationNameSort} setSortState={setPublicationNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"publicationMasterDetails.publicationName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"bookName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((syllabus, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{syllabus?.competitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{syllabus?.competitiveExamBookMasterDetails?.map((item) => `${item.subjectMasterDetails.subjectName} `)}</td>

                                                                                        <td>{syllabus?.publicationMasterDetails?.publicationName}</td>
                                                                                        <td>{syllabus?.bookName}</td>
                                                                                        <td>
                                                                                            {/* <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSyllabusData({
                                                                                                    bookName:syllabus.bookName,
                                                                                                    competitiveExamNameMasterId:syllabus.competitiveExamNameMasterDetails.id,
                                                                                                    publicationMasterId:syllabus.publicationMasterDetails?.id
                                                                                                });
                                                                                                setEditId(syllabus.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button> */}
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" /*disabled={editId === syllabus.id}*/ onClick={() => deleteSyllabus(syllabus.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>

                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: "50px" }}>No Competitive Exam Book Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            {syllabusList && <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={syllabusList.length} />}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CompetitiveExamBookMaster;